/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/tenantsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Tenants. */
var Tenants = /** @class */ (function () {
    /**
     * Create a Tenants.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Tenants(client) {
        this.client = client;
    }
    Tenants.prototype.getTenants = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getTenantsOperationSpec, callback);
    };
    Tenants.prototype.createTenant = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createTenantOperationSpec, callback);
    };
    Tenants.prototype.getTenant = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getTenantOperationSpec, callback);
    };
    Tenants.prototype.updateTenant = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updateTenantOperationSpec, callback);
    };
    Tenants.prototype.deleteTenant = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteTenantOperationSpec, callback);
    };
    return Tenants;
}());
export { Tenants };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getTenantsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/tenants",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "TenantResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createTenantOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/tenants",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateTenantRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.TenantResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getTenantOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/tenants/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.TenantResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateTenantOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/tenants/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.UpdateTenantRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.TenantResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteTenantOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/tenants/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=tenants.js.map